var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    staticClass: "custom-select",
    attrs: { options: _vm.options, label: _vm.label, value: _vm.selected },
    on: {
      input: function($event) {
        return _vm.$emit("setSelected", $event)
      },
      open: function($event) {
        return _vm.$emit("setOpen", true)
      },
      close: function($event) {
        return _vm.$emit("setOpen", false)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ffff624", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ffff624","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/UI/SelectWrapper.vue
// module id = yWbm
// module chunks = 1